jQuery(document).ready(function ($) {

  // Responsive Videos
  $('main').responsivevideos();

  // Tabs
  $('main').tabs({
    dropdown: true,
    desktop: 1025,
    animated: true
  });

  // Accordions
  // $('main').accordions();

  // Form Labels
  formLabels();

  // Format Phone Numbers
  $('[itemprop="telephone"]').each(function () {
    var number = $(this).text();
    var formattedNumber = number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    $(this).wrapInner('<a href="tel:' + formattedNumber + '"></a>');
  });

  //View More for Alternative Accordions List

  function gatherAltAccordions() {
    var r = $.Deferred();
    $(':not(.accordion-alt-item) + .accordion-alt-item, * > .accordion-alt-item:first-of-type').each(function () {
      $(this).nextUntil(':not(.accordion-alt-item)').addBack().wrapAll('<div class="accordions-alt-list active" />');
    });
    return r;
  }

  function accordionAltButton() {
    var r = $.Deferred();
    $('.accordions-alt-list .accordion-alt-item .description').each(function () {
      $(this).append('<a class="read-more" tabindex="0">Read More <span class="fa fa-caret-down"></span></a>')
    });


    $('.accordion-alt-item .read-more').click(function () {
      var $more = $(this).closest('.accordion-alt-item');
      var $toggletext = $(this).closest('.accordion-alt-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.html('Read More <span class="fa fa-caret-down"></span>');
      } else {
        $more.addClass('expanded');
        $toggletext.html('View Less <span class="fa fa-caret-up"></span>');
      }
    });

    $('.accordion-alt-item .read-more').on('keypress', function (e) {
      if (e.which === 13) {
        var $more = $(this).closest('.accordion-alt-item');
        var $toggletext = $(this).closest('.accordion-alt-item .read-more');

        if ($more.hasClass('expanded')) {
          $more.removeClass('expanded');
          $toggletext.html('Read More <span class="fa fa-caret-down"></span>');
        } else {
          $more.addClass('expanded');
          $toggletext.html('View Less <span class="fa fa-caret-up"></span>');
        }
      }
    });
    return r;
  }

  gatherAltAccordions().done(accordionAltButton());
  //View More for Alternative Accordions List - END

  //If subnavigation has no items, then remove
  if (!$('.subnavigation ul').length > 0) {
    $('.subnavigation').remove();
  }
  //If subnavigation has no items, then remove - END

  //If breadcrumb has 1 or less items, then remove
  if ($('.breadcrumbs-container ul li').length <= 1) {
    $('.breadcrumbs-container').remove();
  }
  //If breadcrumb has 1 or less items, then remove - END


  //Subnav Functionality - START
  $('.subnavigation span.more').on('click', function () {
    $('.subnavigation').toggleClass('active');
  });

  $('.subnavigation span.more').on('keypress', function (e) {
    if (e.which === 13) {
      $('.subnavigation').toggleClass('active');
      $('.subnavigation ul li a:last').on('focusout', function () {
        $('.subnavigation.active').removeClass('active');
      });
    }
  });

  // checks to see if the practice test is active and if so , adds class to the main content

  if ($(".content-form").length > 0 && $("body.pre-license-courses").length > 0) {
    $(".content-section").addClass("practice-test");
  }




  // splide code
  new Splide('.testimonials2', {
    type: 'fade',
    perPage: 1,
    cover: true,
    arrows: false,
    pagination: true,
    autoHeight: true,
    heightRatio: true,
    gap: 0,
    autoplay: true,
    interval: 5000,
    rewind: true,
    // breakpoints: {
    //   768: {
    //     perPage: 1,
    //     pagination: true
    //   },
    //   1024: {
    //     perPage: 2,
    //     pagination: true
    //   },
    // },
    classes: {
      pagination: 'splide__pagination dots', // container
      arrows: 'splide__arrows your-class-arrows',
      arrow: 'splide__arrow your-class-arrow',
      prev: 'splide__arrow--prev your-class-prev',
      next: 'splide__arrow--next your-class-next',
    },
  }).mount();


console.log('ready load');
  

});

$(window).on("load", function(){
  // These are the calls to add hyphen masking to ssns and phonenumbers

  // Phone
  $("input.PhoneMask").inputmask("999-999-9999");
  // SSN
  $("input.SSNMask").inputmask("999-99-9999");

  console.log('window load');
});

// Form Labels
function formLabels() {
  // Forms
  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').focus(function () {
    $(this).parent('div').addClass('focused');
  });

  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').blur(function () {
    var inputValue = $(this).val();
    // console.log(inputValue);
    if (inputValue === '') {
      $(this).parent('div').removeClass('focused');
    }
  });
  // File Upload
  $('input[type="file"]').each(function () {
    $(this).next('label').after('<span class="file"></span>');
    $(this).on('change', function () {
      var filePath = $(this).val();
      var splitFilePath = filePath.split('\\');
      var fileName = splitFilePath[splitFilePath.length - 1];
      var file = $(this).closest('div').find('.file');
      if (filePath.length === 0) {
      } else {
        file.text(fileName);
      }
    });
  });
}
// Fires Functions on Partial Postback and Page Load
function pageLoad() {
  formLabels();
}